import JSZip from 'jszip'
import { saveAs } from 'file-saver'
// @ts-ignore
import * as JSZipUtils from 'jszip-utils'

const useZip = () => {
    const generateZip = async (list: any[]) => {
        let zip = JSZip()
        let count = 1
        if (list.length > 0) {
            list.forEach((element) => {
                JSZipUtils.getBinaryContent(element.path, async (err: any, data: any) => {
                    if (err) {
                        throw err // or handle the error
                    }
                    new Promise((resolve) => {
                        zip.file(`${element.folderName}/${element.filename}`, data, {
                            binary: true,
                        })
                        resolve('')
                    }).finally(() => {
                        count++
                    })
                })
            })
            const interval = setInterval(() => {
                if (count >= list.length) {
                    zip.generateAsync({ type: 'blob' }).then(function (blob) {
                        saveAs(blob, `Documents_${new Date().toLocaleString()}.zip`)
                    })
                    clearInterval(interval)
                }
            }, 400)
        }
    }
    return { generateZip }
}

export default useZip
